import React from 'react';

/**
 * A marked day's icon, with its date number waiting underneath (Rob, 03/11/2026: "when you roll
 * over the date … the date number shows in the box rather than the sun icon, but the background
 * is still orange"). Pure CSS (`index.css`, `.hh-day`): while the pointer is on the day the icon
 * fades out and the number shows. Keyboard was considered and dropped (Rob, 03/11/2026). Nothing about
 * clicking or booking changes. Phones are left as they were (Rob 3A): the swap only happens on a
 * device that can point (`@media (hover: hover)`).
 *
 * The day's cell needs the `hh-day` class. `DayMark` puts the number in the icon's place;
 * `DayNumberOver` centres it over the whole cell (half days, timed bookings, birthdays, where the
 * icon sits in a corner or is a bow).
 */
export const DayMark = ({ n, numClass = '', children }) => (
  <span className="hh-day-mark">
    <span className="hh-day-icon">{children}</span>
    <span className={`hh-day-num ${numClass}`} aria-hidden="true">{n}</span>
  </span>
);

export const DayNumberOver = ({ n, numClass = '' }) => (
  <span
    className={`hh-day-num absolute inset-0 z-[31] flex items-center justify-center ${numClass}`}
    aria-hidden="true"
  >
    {n}
  </span>
);

export default DayMark;
